export default {
  table: {
    shop: 'Shop',
    index: 'Index',
    onShelf: 'Launched',
    offShelf: 'Removed',
    soldOut: 'Sold Out',
    total: 'Total',
    view: 'View',
    subscribed: 'Subscribed',
    nonSubscribed: 'Non-subscribed',
    all: 'All',
    selectLabel: 'Monitoring status',
    status: 'Monitoring status',
    download: 'Download',
  },
  favorites: {
    view: 'View',
    confirm: 'Confirm',
    shop: 'shop',
    favorites: 'Favorites',
    skuFavorites: 'SKU in Favorites',
    detail: 'Detail',
    group: {
      image: 'Image',
      name: '',
      category: 'Category',
      brand: 'Brand',
    },
  },
};
